import Rails from 'rails-ujs';

Rails.start();

import 'bootstrap/dist/js/bootstrap';
import 'flatpickr/dist/flatpickr';
import '@fortawesome/fontawesome-free/js/all';

$(function () {
  // ダブルサブミット対策
  $('form').submit(function() {
    const self = this;
    $(':submit', self).prop('disabled', true);
    setTimeout(function() {
      $(':submit', self).prop('disabled', false);
    }, 10000);
  });

  // 検索フォームの日付選択 (flatpickr)
  $(".flatpickr").flatpickr();
});